module.exports = __webpack_public_path__ + "images/down-icon.6cb8668fadc7c8ce10d6bd61339230fc.png";